<template>
  <div class="news-school-detail">
       <breadCrumb></breadCrumb>
       <div class="news-school-detail-wrapper main flex-between">
           <div class="side-navbar">
               <div class="title f20">{{schoolInfo.name}}</div>
               <ul >
                   <li v-for="(li, index) in navbarList" 
                       :key="index"
                       :class="{'active':isActive===index}" 
                       @click="isActive = index">
                        <a href="javascript:;" @click="clickLi(index)"><i></i>{{li}}</a>
                    </li>
               </ul>
           </div>
           <div class="school-detail"  v-show="isActive === 0">
               <img :src="schoolInfo.cover" alt="">
               <table class="basic-msg-table flex-align-between">
                   <tr>
                       <td>中文名</td>
                       <td>{{schoolInfo.name}}</td>
                       
                   </tr>
                   <tr>
                       <td>类别</td>
                       <td>公立小学</td>
                   </tr>
                   <tr>
                       <td>简称</td>
                       <td>{{schoolInfo.abb}}</td>
                   </tr>
                   <tr>
                       <td>现任校长</td>
                       <td>{{schoolInfo.leader}}</td>
                   </tr>
                   <tr>
                       <td>创办时间</td>
                       <td>{{schoolInfo.buildTime}}</td>
                   </tr>
                   <tr>
                       <td>同属地区</td>
                       <td>{{schoolInfo.location}}</td>
                   </tr>
               </table>
               <p class="f14">{{schoolInfo.evaluation}}</p>
           </div>
           <!-- <div class="school-leader"  v-show="isActive === 1">
                <img src="" alt="">
                <p>{{schoolInfo.leaderInfo}}</p>
           </div> -->
           <div class="school-assess" v-show="isActive === 1">
                <p v-if="schoolInfo.detail" v-html="schoolInfo.detail"></p>
                <p v-else>暂无评价</p> 
           </div>
       </div>
       <!-- <div class="footer-section">
            <footer-view></footer-view>
       </div> -->
  </div>
</template>

<script>
export default {
    data() {
        return {
            isActive:0,
            navbarList:['学校简介','参与项目优秀评价'],
            // '学校领导人',
            schoolInfo:{},
        }
    },
    methods: {
        backTop() {
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        },
        clickLi(index) {
            this.isActive = index;
            this.backTop();
        },
        async GetSchoolInfo(){
            let params = {
                id : this.$route.params.id
            }
            let resData = await Api.News.getSchoolInfo(params)
            console.log(resData.data)
            this.schoolInfo = resData.data
         }
    },
    mounted(){
        this.GetSchoolInfo();
    }
}
</script>

<style lang="less">
    @import "../less/news_school_detail.less";
</style>